const requiredEnvVars = ['REACT_APP_OPENAI_API_KEY'];

requiredEnvVars.forEach(envVar => {
  if (!process.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
});

export const config = {
  openaiApiKey: process.env.REACT_APP_OPENAI_API_KEY,
}; 